// src/config.js
const ROLL_CALL_API_BASE_URL = process.env.REACT_APP_API_URL;
const FILESERVER_PATH = process.env.REACT_APP_FILESERVER;
const ROLL_CALL_IMG_PATH = process.env.REACT_APP_DOWNLOADPATH;
const NOTIFICATIONS_API = process.env.REACT_APP_NOTIFY_URL;
 
const ROLL_CALL_LOGIN = "portal/user/login";
const ROLL_CALL_EMPLOYEES_LIST = "portal/emp/getemployees";
const Bear_Token = "kbsakjdnlsajdsj";

export const getAuthToken = () => {
  return sessionStorage.getItem("authToken");
};

export const getSuperId = () => {
  return sessionStorage.getItem("superId");
};

export const getSessionData = () => ({
  token: sessionStorage.getItem("authToken"),
  superId: sessionStorage.getItem("superId"),
});

export {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_LOGIN,
  NOTIFICATIONS_API,
  ROLL_CALL_EMPLOYEES_LIST,
  Bear_Token,
  ROLL_CALL_IMG_PATH,
  FILESERVER_PATH,
};